import { Component } from 'react';
import { connect } from 'react-redux';

import Form from 'components/atoms/Form';
import Icon from 'components/atoms/Icon';
import { RootState } from 'types';
import { ActionsType, SystemType } from 'types/system';
import { checkDifferent } from 'utils/formHandlers';
import { translate } from 'utils/translate';

interface keyboardShortcutsModelProps {
    //unused props
    children?: string | JSX.Element | JSX.Element[];

    //unused props
    language: string;

    //unused props
    system: SystemType;

    id?: string;

    //used props in unused state
    data: any;

    actions: ActionsType | undefined;
}

interface keyboardShortcutsModelState {
    //unused state
    errors: object;

    //unused state
    system: SystemType;

    //unused state
    data: any | null;
}

class keyboardShortcutsModel extends Component<keyboardShortcutsModelProps, keyboardShortcutsModelState> {
    constructor(props: keyboardShortcutsModelProps) {
        super(props);
        this.state = {
            system: props.system,
            data: props.data,
            errors: {},
        };
    }

    static getDerivedStateFromProps(props: keyboardShortcutsModelProps, state: keyboardShortcutsModelState) {
        if (checkDifferent(props.system, state.system)) {
            return { system: props.system };
        }
        return null;
    }

    handleFormSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e?.preventDefault();
        this.props.actions?.onCancel();
    };

    handleFormCancel = () => {
        this.props.actions?.onCancel();
    };

    render() {
        return (
            <>
                <Form onSubmit={this.handleFormSubmit} className="bg-white shadow p-4 w-full rounded">
                    <div id={`Drag-${this.props.id}`} className="flex justify-between mb-4 no-select ">
                        <div className="text-lg leading-6 font-bold">{translate('Keyboard shortcuts')} </div>
                        <div
                            onTouchEnd={this.handleFormCancel}
                            onClick={this.handleFormCancel}
                            className="cursor-pointer"
                        >
                            <Icon>
                                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                <path d="M18 6l-12 12" />
                                <path d="M6 6l12 12" />
                            </Icon>
                        </div>
                    </div>
                    <div className="flex items-center gap-3 mb-3">
                        <div className="text-gray-400 ">{translate('Common actions')}</div>
                    </div>

                    <div className="flex justify-between  items-center gap-3 mb-3">
                        <div className=" text-bold ">{translate('Show system console')}</div>
                        <div className="text-gray-400 ">
                            <Icon className="w-6 h-6">
                                <path d="M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z"></path>
                                <path d="M14.5 12h-.5a1 1 0 0 1 -1 -1v-1a1 1 0 0 1 1 -1h1a1 1 0 0 1 1 1v1a1 1 0 0 1 -1 1h-1a1 1 0 0 0 -1 1v1a1 1 0 0 0 1 1h1a1 1 0 0 0 1 -1v-1a1 1 0 0 0 -1 -1"></path>
                                <path d="M8 12h2"></path>
                                <path d="M10 9h-2v6"></path>
                            </Icon>
                        </div>
                    </div>
                    <div className="flex justify-between gap-3 mb-3">
                        <div className=" text-bold ">{translate('Close open modal')}</div>
                        <div className="text-gray-400 ">
                            <Icon className="w-6 h-6">
                                <path d="M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z"></path>

                                <g>
                                    <path
                                        style={{ strokeWidth: 0.5, fill: 'currentcolor' }}
                                        d="M 4.455 14.823 L 4.455 9.812 L 8.171 9.812 L 8.171 10.66 L 5.467 10.66 L 5.467 11.771 L 7.983 11.771 L 7.983 12.615 L 5.467 12.615 L 5.467 13.979 L 8.266 13.979 L 8.266 14.823 Z M 9.668 13.193 L 10.652 13.097 Q 10.741 13.593 11.013 13.825 Q 11.284 14.057 11.746 14.057 Q 12.234 14.057 12.482 13.851 Q 12.73 13.644 12.73 13.367 Q 12.73 13.189 12.626 13.064 Q 12.522 12.94 12.262 12.847 Q 12.084 12.786 11.452 12.629 Q 10.638 12.427 10.31 12.133 Q 9.849 11.719 9.849 11.125 Q 9.849 10.742 10.066 10.409 Q 10.283 10.075 10.691 9.901 Q 11.1 9.727 11.677 9.727 Q 12.621 9.727 13.098 10.14 Q 13.574 10.554 13.598 11.244 L 12.587 11.289 Q 12.522 10.903 12.308 10.733 Q 12.094 10.564 11.667 10.564 Q 11.226 10.564 10.977 10.745 Q 10.816 10.862 10.816 11.056 Q 10.816 11.234 10.966 11.361 Q 11.158 11.521 11.896 11.696 Q 12.634 11.87 12.988 12.056 Q 13.342 12.242 13.542 12.565 Q 13.742 12.888 13.742 13.364 Q 13.742 13.794 13.503 14.17 Q 13.263 14.546 12.826 14.729 Q 12.388 14.912 11.735 14.912 Q 10.785 14.912 10.276 14.473 Q 9.767 14.033 9.668 13.193 Z M 18.599 12.981 L 19.58 13.292 Q 19.354 14.112 18.829 14.51 Q 18.305 14.908 17.498 14.908 Q 16.5 14.908 15.857 14.227 Q 15.215 13.545 15.215 12.362 Q 15.215 11.111 15.861 10.419 Q 16.507 9.727 17.56 9.727 Q 18.479 9.727 19.053 10.27 Q 19.395 10.592 19.566 11.193 L 18.564 11.432 Q 18.476 11.043 18.194 10.817 Q 17.912 10.592 17.508 10.592 Q 16.951 10.592 16.604 10.991 Q 16.257 11.391 16.257 12.287 Q 16.257 13.237 16.599 13.64 Q 16.941 14.044 17.488 14.044 Q 17.891 14.044 18.182 13.787 Q 18.472 13.531 18.599 12.981 Z"
                                    />
                                </g>
                            </Icon>
                        </div>
                    </div>
                    <div className="flex justify-between gap-3 mb-3">
                        <div className=" text-bold ">{translate('Zoom in')}</div>
                        <div className="text-gray-400 ">
                            <Icon className="w-6 h-6">
                                <path d="M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z"></path>
                                <path d="M10 14h4"></path>
                                <path d="M12 12v4"></path>
                            </Icon>
                        </div>
                    </div>
                    <div className="flex justify-between gap-3 mb-3">
                        <div className=" text-bold ">{translate('Zoom out')}</div>
                        <div className="text-gray-400 ">
                            <Icon className="w-6 h-6">
                                <path d="M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z"></path>
                                <path d="M10 14h4"></path>
                            </Icon>
                        </div>
                    </div>
                    <div className="flex items-center gap-3 mb-3">
                        <div className="text-gray-400 ">
                            {translate('Click multiple/single transits were under the selection click point.')}
                        </div>
                    </div>

                    <div className="flex justify-between gap-3 mb-3">
                        <div className=" text-bold ">
                            {translate(
                                'up/down cycled through transits when multiple transits were under the selection click point'
                            )}
                        </div>
                        <div className="text-gray-400 flex justify-between gap-2 ">
                            <Icon className="w-6 h-6">
                                <path d="M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z"></path>

                                <path d="M9 13l3 -3l3 3" />
                            </Icon>
                            <Icon className="w-6 h-6">
                                <path d="M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z"></path>

                                <path d="M15 11l-3 3l-3 -3" />
                            </Icon>
                        </div>
                    </div>

                    <div className="flex justify-between gap-3 mb-3">
                        <div className=" text-bold ">{translate(' Left/right stepped along selected')}</div>
                        <div className="text-gray-400 flex justify-between gap-2 ">
                            <Icon className="w-6 h-6">
                                <path d="M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z"></path>

                                <path d="M13 15l-3 -3l3 -3" />
                            </Icon>
                            <Icon className="w-6 h-6">
                                <path d="M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z"></path>

                                <path d="M11 9l3 3l-3 3" />
                            </Icon>
                        </div>
                    </div>
                </Form>
            </>
        );
    }
}

const mapStateToProps = (state: RootState) => ({
    language: state.user.user.language,
    system: state.port.system,
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const mapDispatchToProps = () => ({});

export default connect(mapStateToProps, mapDispatchToProps)(keyboardShortcutsModel);
